import React from 'react';

import Modal from 'react-modal';
import modal from '../../../definitions/Modal';
import { FormattedMessage } from 'react-intl';
import Row from '../../../components/tag/Row';
import Span from '../../../components/tag/Span';
import OTButtonGroup from '../../../components/tag/OTButtonGroup';
import OTButton from '../../../components/tag/OTButton';
import { connect } from 'react-redux';
import { getInsideParentheses } from '../../../utils/Functions';
import { withRouter } from 'react-router-dom';

import {
  hideRescheduleTransitionModal,
  navigateToReschedule,
} from '../data/actions';
import { TIMELINE } from '../../../data/reducer';

const { id: module_id } = module;

const modalStyle = modal({ content: { width: '400px' } });

const clinicMap = {
  HPVA: {
    name: 'Vatsakeskus',
    link: 'http://www.tays.fi/fi-FI/Toimipaikat/Tays_Hatanpaa/Hoitoyksikot/Vatsakeskus',
  },
  HUAT: {
    name: 'Äitiysultra',
    link: 'http://tays.fi/fi-FI/Toimipaikat/Tays_Keskussairaala/Hoitoyksikot/Aitiysultra',
  },
};

class TimelineRescheduleTransitionModal extends React.Component {
  closeModal = () => {
    let { dispatch } = this.props;
    dispatch(hideRescheduleTransitionModal());
  };

  goToReschedule = () => {
    let {
      dispatch,
      history,
      showRescheduleTransitionModalForNotification: appointmentId,
    } = this.props;
    dispatch(navigateToReschedule(appointmentId, history));
  };

  resolveClinicDetails = (clinic) => {
    let clinicDetails = clinicMap[clinic];
    let clinicName, clinicLink;
    if (clinicDetails) {
      clinicName = clinicDetails.name;
      clinicLink = clinicDetails.link;
    }

    return {
      clinicName,
      clinicLink,
    };
  };

  render() {
    let { data, showRescheduleTransitionModalForNotification } = this.props;
    if (!data) return null;

    let chosen =
      data.length > 0 &&
      data.filter(
        (item) => item.id === showRescheduleTransitionModalForNotification
      )[0];
    let clinic = chosen && getInsideParentheses(chosen.department);
    let { clinicName, clinicLink } = this.resolveClinicDetails(clinic);

    return (
      <Modal
        ariaHideApp={false}
        isOpen={showRescheduleTransitionModalForNotification !== false}
        style={modalStyle}
      >
        <Row>
          <Span>
            <h4 className={'ot-modal__title'}>
              <FormattedMessage id={`${module_id}.title`} />
            </h4>
          </Span>
        </Row>
        <Row>
          <Span>
            {clinicName && clinicLink ? (
              <p>
                <FormattedMessage
                  id={`${module_id}.content.with.clinic`}
                  values={{
                    name: clinicName,
                    a: (chunks) => (
                      <a target="_blank" href={clinicLink}>
                        {chunks}
                      </a>
                    ),
                  }}
                />
              </p>
            ) : (
              <p>
                <FormattedMessage id={`${module_id}.content`} />
              </p>
            )}
          </Span>
        </Row>
        <Row>
          <Span>
            <OTButtonGroup fullWidth={true} type="big">
              <OTButton onClick={this.closeModal}>
                <FormattedMessage id="back" />
              </OTButton>
              <OTButton onClick={this.goToReschedule}>
                <FormattedMessage id="change.time" />
              </OTButton>
            </OTButtonGroup>
          </Span>
        </Row>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  let { data, showRescheduleTransitionModalForNotification } = state[TIMELINE];
  return {
    data,
    showRescheduleTransitionModalForNotification:
      showRescheduleTransitionModalForNotification,
  };
};

export default withRouter(
  connect(mapStateToProps)(TimelineRescheduleTransitionModal)
);
